import { cookieUtils } from '@libs/utils'
import { tokenName } from "@/config/setting.config"

export function getToken() {
  return cookieUtils.getCookie(tokenName)
}

export function setToken(token) {
  return cookieUtils.setCookie(tokenName, 'token')
}

export function removeToken() {
  return cookieUtils.delCookie(tokenName)
}

export function getUserId() {
  return cookieUtils.getCookie('sampUserId')
}

export function setUserId(userId) {
  return cookieUtils.setCookie('sampUserId', userId)
}

export function removeUserId() {
  return cookieUtils.delCookie('sampUserId')
}

export function getRegId() {
  return cookieUtils.getCookie('regId')
}

export function setRegId(regId) {
  return cookieUtils.setCookie('regId', regId)
}

export function removeRegId() {
  return cookieUtils.delCookie('regId')
}
